<template>
    <st-loading-styled v-if="visible" :size="size" :align="align" :color="color" :stroke="stroke">
        <st-divider v-if="comment" class="st-loading__text" :between="1.6" v-html="comment" />
        <div class="st-loading" />
    </st-loading-styled>
</template>

<script>
import styled, { css, keyframes } from "vue-styled-components";
import { lighten } from "polished";

const props = {
    size: {
        type: Number,
        default: () => 4.2
    },
    color: {
        type: String,
        default: () => "primary"
    },
    stroke: {
        type: Number,
        default: () => 4
    },
    align: {
        type: String,
        default: () => "center"
    },
    comment: String
};

const Animate = keyframes`
    100% {
        transform: rotateZ(360deg);
    } 0% {
        transform: rotateZ(0deg);
    }
`;

const StLoadingStyled = styled("div", props)`
    display: inline-block;
    width: 100%;
    padding: ${props => Math.floor(props.size / 2)}rem 0;
    text-align: ${props => props.align};
    font-size: 0;

    .st-loading {
        display: inline-block;
        width: ${props => props.size}rem;
        height: ${props => props.size}rem;
        animation: ${Animate} 1s linear infinite;
        border-radius: 50%;

        ${props => {
            const color = props.theme.color[props.color] || props.color;
            return css`
                border: ${props => props.stroke}px solid ${props => lighten(0.2, color)};
                border-left-color: ${color};
            `;
        }}

        &__text {
            font-size: 1.6rem;
            text-align: center;
            font-weight: bold;
        }
    }
`;

export default {
    name: "StLoading",
    props: {
        ...props,
        visible: Boolean
    },
    components: {
        StLoadingStyled
    }
};
</script>
